import type { IPost } from "../../../../types/models/post.models.types";
import { usePutHttp } from "../../http.hook";

interface IResponse {
  post: IPost;
}

export function useUnflagPostAdminHttp() {
  return usePutHttp<null, IResponse>({
    path: "/admin/posts/:id/unflag",
  });
}
